export const Spinner = {
  baseStyle: {
    color: "brand.primary",
  },
};
